// import { Injectable } from '@angular/core';
// import { Workbook } from 'exceljs';
// import { saveAs } from 'file-saver-es';
// import { exportDataGrid } from 'devextreme/excel_exporter';
// import { DxDataGridComponent } from 'devextreme-angular';

// @Injectable({
//   providedIn: 'root'
// })
// export class ExcelExportService {

//   constructor() { }

//   /**
//    * Exports a DevExtreme DataGrid instance to Excel.
//    * @param gridInstance DxDataGrid instance
//    * @param fileName Excel file name (default = 'export.xlsx')
//    * @param sheetName Excel sheet name (default = 'Sheet1')
//    */
//   exportDataGrid(gridInstance: DxDataGridComponent['instance'], fileName: string = 'export.xlsx', sheetName: string = 'Sheet1') {
//     if (!gridInstance) {
//       console.error('❌ DataGrid instance not found!');
//       return;
//     }

//     const workbook = new Workbook();
//     const worksheet = workbook.addWorksheet(sheetName);

//     exportDataGrid({
//       component: gridInstance,
//       worksheet,
//       autoFilterEnabled: true,
//     }).then(() => {
//       workbook.xlsx.writeBuffer().then((buffer) => {
//         saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
//       });
//     });
//   }

//   exportRows(
//     rows: any[],
//     columns: Array<{ key: string; header: string }>,
//     fileName: string = 'export.xlsx',
//     sheetName: string = 'Sheet1'
//   ) {
//     if (!columns?.length) {
//       console.error('❌ Export columns not provided!');
//       return;
//     }

//     const workbook = new Workbook();
//     const worksheet = workbook.addWorksheet(sheetName);

//     worksheet.addRow(columns.map((column) => column.header));

//     (rows || []).forEach((row) => {
//       const excelRow = columns.map((column) => {
//         const value = row?.[column.key];
//         return value ?? '';
//       });
//       worksheet.addRow(excelRow);
//     });

//     worksheet.autoFilter = {
//       from: { row: 1, column: 1 },
//       to: { row: 1, column: columns.length }
//     };

//     worksheet.columns.forEach((column) => {
//       column.width = 18;
//     });

//     workbook.xlsx.writeBuffer().then((buffer) => {
//       saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
//     });
//   }
// }



import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { DxDataGridComponent } from 'devextreme-angular';
import * as ExcelJS from 'exceljs';

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {

  constructor() { }

  /**
   * Exports a DevExtreme DataGrid instance to Excel.
   * @param gridInstance DxDataGrid instance
   * @param fileName Excel file name (default = 'export.xlsx')
   * @param sheetName Excel sheet name (default = 'Sheet1')
   * @param srNoDataField Sr. No. column dataField name (default = 'srNo')
   */

  exportDataGrid(
    gridInstance: DxDataGridComponent['instance'],
    fileName: string = 'export.xlsx',
    sheetName: string = 'Sheet1',
    srNoDataField: string = 'srNo',
    extraColumnsToReveal: string[] = []
  ) {
    if (!gridInstance) {
      console.error('❌ DataGrid instance not found!');
      return;
    }

    const pageIndex = gridInstance.pageIndex();
    const pageSize = gridInstance.pageSize();
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    let srCounter = (pageIndex * pageSize);

    extraColumnsToReveal.forEach((field) => {
      gridInstance.columnOption(field, 'visible', true);
    });

    const restoreVisibility = () => {
      extraColumnsToReveal.forEach((field) => {
        gridInstance.columnOption(field, 'visible', false);
      });
    };

    exportDataGrid({
      component: gridInstance,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }: { gridCell: any; excelCell: any }) => {
        if (
          gridCell?.column?.dataField === srNoDataField &&
          gridCell.rowType === 'data'
        ) {
          srCounter++;
          excelCell.value = srCounter;
        }
      }
    }).then(() => {
      restoreVisibility();
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
      });
    }).catch((err) => {
      restoreVisibility();
      console.error('❌ Export failed:', err);
    });
  }
  /**
   * Exports plain rows array to Excel (no DataGrid needed).
   * @param rows Data array
   * @param columns Column definitions with key and header
   * @param fileName Excel file name (default = 'export.xlsx')
   * @param sheetName Excel sheet name (default = 'Sheet1')
   */
  exportRows(
    rows: any[],
    columns: Array<{ key: string; header: string }>,
    fileName: string = 'export.xlsx',
    sheetName: string = 'Sheet1'
  ) {
    if (!columns?.length) {
      console.error('❌ Export columns not provided!');
      return;
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    worksheet.addRow(columns.map((column) => column.header));

    (rows || []).forEach((row) => {
      const excelRow = columns.map((column) => {
        const value = row?.[column.key];
        return value ?? '';
      });
      worksheet.addRow(excelRow);
    });

    worksheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: columns.length }
    };

    worksheet.columns.forEach((column) => {
      column.width = 18;
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
    });
  }


  // 

  private formatDateOnly(isoString: string): string {
    if (!isoString) return '';
    const datePart = isoString.split('T')[0];
    const [year, month, day] = datePart.split('-');
    return `${day}/${month}/${year}`;
  }

  exportSalesEntryListWithItems(data: any[], fileName: string = 'Sales-Entry-List.xlsx'): void {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Sales Entry');

    const invoiceHeaders = ['Sr No', 'Invoice No', 'Invoice Date', 'Customer Name', 'Sales Person', 'Total Amt', 'Due Amt'];
    const itemHeaders = [
      'Sr No', 'Bag No', 'Material Type', 'Style', 'Diamond Weight', 'Diamond Quantity',
      'Diamond Clarity', 'Net Wt (In Gram)', 'Gross Weight', 'Karat', 'Pcs',
      'IGI No', 'HUID', 'HSN No', 'Price Type', 'Complexity', 'Complexity Percentage', 'Price'
    ];

    const headerFill: ExcelJS.Fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE8EEF7' } };
    let r = 1;

    data.forEach((invoice, idx) => {
      const invHeaderRow = sheet.getRow(r);
      invoiceHeaders.forEach((h, i) => {
        const cell = invHeaderRow.getCell(1 + i);
        cell.value = h;
        cell.font = { bold: true };
        cell.fill = headerFill;
      });
      r++;

      const invRow = sheet.getRow(r);
      invRow.getCell(1).value = idx + 1;
      invRow.getCell(2).value = invoice.invoiceName;
      invRow.getCell(3).value = this.formatDateOnly(invoice.invoiceDate);
      invRow.getCell(4).value = invoice.customerName;
      invRow.getCell(5).value = invoice.salesPersonName;
      invRow.getCell(6).value = invoice.totalAmount;
      invRow.getCell(6).numFmt = '#,##0.00';
      invRow.getCell(7).value = invoice.dueAmount;
      invRow.getCell(7).numFmt = '#,##0.00';
      r++;

      const items = invoice.salesEntryListItems || [];

      if (items.length === 0) {
        sheet.getRow(r).getCell(2).value = 'No item details found.';
        sheet.getRow(r).getCell(2).font = { italic: true };
        r++;
      } else {
        const itemHeaderRow = sheet.getRow(r);
        itemHeaders.forEach((h, i) => {
          const cell = itemHeaderRow.getCell(2 + i);
          cell.value = h;
          cell.font = { bold: true };
          cell.fill = headerFill;
        });
        r++;

        items.forEach((item: any, itemIdx: number) => {
          const row = sheet.getRow(r);
          const values = [
            itemIdx + 1, item.bagNo, item.materialType, item.style,
            item.diaWt, item.diaQty, item.diamondClarity, item.netWt, item.grossWt,
            item.karat, item.pcs, item.igiNo, item.huid, item.hSNO,
            item.isSRP, item.complexityName, item.complexityPercentage, item.selingPrice
          ];
          values.forEach((v, i) => row.getCell(2 + i).value = v ?? '');
          row.getCell(2 + 4).numFmt = '0.000';
          row.getCell(2 + 7).numFmt = '0.000';
          row.getCell(2 + 8).numFmt = '0.000';
          row.getCell(2 + 17).numFmt = '#,##0.00';
          r++;
        });
      }

      r++;
    });

    sheet.columns.forEach(col => col.width = 16);

    workbook.xlsx.writeBuffer().then(buffer => {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
    });
  }
}